import * as R from 'ramda';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import * as CountryRegionHelper from 'js/country_region_helper/index';

class StateInput extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        validationState: PropTypes.string,
        value: PropTypes.string,
        country: PropTypes.string
    };

    shouldComponentUpdate(nextProps) {
        return (
            nextProps.value !== this.props.value ||
            nextProps.validationState !== this.props.validationState ||
            nextProps.country !== this.props.country
        );
    }

    render() {
        const {value, validationState, onChange, country} = this.props;

        const isDisabled = R.isEmpty(country);

        const regions = CountryRegionHelper.RegionsByCountryShortCode[country];

        const options = R.pipe(
            R.keys,
            R.map(key => (
                <option key={key} value={key}>
                    {regions[key]}
                </option>
            )),
            R.prepend(
                <option key="" value="">
                    Select your state
                </option>
            )
        )(regions);

        return (
            <FormGroup validationState={validationState}>
                <ControlLabel>State</ControlLabel>
                <FormControl
                    style={{fontSize: 16, lineHeight: '16px'}}
                    name="profile[state]"
                    componentClass="select"
                    value={value}
                    defaultValue=""
                    onChange={e => onChange(e.target.value)}
                    disabled={isDisabled}
                >
                    {options}
                </FormControl>
            </FormGroup>
        );
    }
}

export default StateInput;



// WEBPACK FOOTER //
// ./creator/components/address_info_form/components/state_input.js